/* eslint-disable */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unstable-nested-components */
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AlertAdapter, RegularButton } from 'pg-ui-library';
import { ReactComponent as BenefitsPendingIcon } from 'src/assets/benefits-pending.svg';
import { ReactComponent as BenefitsAvailableIcon } from 'src/assets/benefits-available.svg';
import BenefitsDoneIcon from 'src/assets/benefits-done.svg';
import { useQuery } from '@tanstack/react-query';
import benefitsService from 'src/services/benefits.service';

import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { monetaryUSDFormat } from 'src/utils/currencyFormat';
import { IBenefit } from 'src/interfaces';
import { useActions } from 'src/hooks/useActions';
import { BenefitsListTable } from './components/benefits-deductions-list';
import CurrentBenefits from './components/current-benefits';
import CartTabs from './components/cart-tabs';
import {
  Container,
  Header,
  HeaderTitle,
  Content,
  HeaderItemLeft,
  HeaderItemRight,
  ScrollableContainer,
  ScrollableContainerEmpty,
  TabBenefits,
  TabBenefitsContent,
} from './styles';
import AvailableBenefitsCard from './components/available-benefits-card';

/**
 * Since we depend on some specific types to run validations we change the label manually here.
 * @param type string
 */
export const benefitTypeAlias = (type: string) => {
  if (typeof type === 'string' && type.startsWith('Vol')) {
    const replacedString = type.replace(/^Vol/, 'Voluntary');

    return replacedString;
  }

  return type;
};

export const benefitsForbiddenWords = ['-External', '-Internal'];

export const benefitsCategories: string[] = ['Health & Well-being', 'Income Security', 'Retirement & Lifestyle'];

export enum BenefitEventType {
  // eslint-disable-next-line no-unused-vars
  NEW_HIRE = 'new_hire',
  // eslint-disable-next-line no-unused-vars
  OPEN_ENROLLMENT = 'open_enrollment',
  // eslint-disable-next-line no-unused-vars
  QLE = 'qle',
  // eslint-disable-next-line no-unused-vars
  UPDATE_ENROLLMENT = 'update_enrollment',
}

// eslint-disable-next-line no-unused-vars
const PendingBenefitsList: React.FC<{
  pendingBenefits: IBenefit[];
}> = ({ pendingBenefits }) => (
  <ScrollableContainer>
    {pendingBenefits?.map((benefit: IBenefit, index: number) => (
      <AvailableBenefitsCard
        // eslint-disable-next-line react/no-array-index-key
        key={index}
        imgURL={benefit.imgURL}
        benefitId={benefit.benefitId}
        title={benefit.planDescription}
        subtitle={benefit.dependentsDescription ? benefit.dependentsDescription : benefit.optionDescription}
        fee={monetaryUSDFormat(benefit.price)}
        date=""
        editMode={false}
        deleteMode={false}
      />
    ))}
  </ScrollableContainer>
);

// eslint-disable-next-line no-unused-vars
const AvailableBenefitsList: React.FC<{
  availableBenefits: IBenefit[];
}> = ({ availableBenefits }) => (
  <ScrollableContainer>
    {availableBenefits?.map((benefit: IBenefit) => (
      <AvailableBenefitsCard
        key={benefit.benefitId}
        imgURL={benefit.imgURL}
        benefitId={benefit.benefitId}
        title={benefit.planDescription}
        subtitle={benefit.dependentsDescription ? benefit.dependentsDescription : benefit.optionDescription}
        fee={benefit.fixedAmount ? monetaryUSDFormat(benefit.fixedAmount) : benefit.percent}
        date={benefit.expiration}
        editMode={false}
        deleteMode={false}
      />
    ))}
  </ScrollableContainer>
);

const EmptyBenefitsAvailable: React.FC = () => (
  <ScrollableContainerEmpty>
    <img src={BenefitsDoneIcon} />
    <h3 style={{ margin: 0 }}>No Available Benefits</h3>
    <p style={{ margin: 0 }}>There are no available benefits</p>
    <p style={{ margin: 0 }}>Awaiting for open enrollment date</p>
  </ScrollableContainerEmpty>
);

const EmptyPending: React.FC = () => (
  <ScrollableContainerEmpty>
    <img src={BenefitsDoneIcon} />
    <h3 style={{ margin: 0 }}>No Pending Benefits</h3>
    <p style={{ margin: 0 }}>There are no pending benefits</p>
    <p style={{ margin: 0 }}>Awaiting for approval</p>
  </ScrollableContainerEmpty>
);

const BenefitsPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { getPersonalInfo } = useActions();
  const [active, setActive] = useState<string>('active');

  // eslint-disable-next-line no-unused-vars
  const { isNewHire, isQle, isEnrollmentOpen, isOpenEnrollment, isBenefitUpdate } = useTypedSelector(
    state => state.benefits.data
  );
  // const hasBenefits = benefits.length > 0;

  // eslint-disable-next-line no-unused-vars
  const { isLoading: availableBenefitsLoading, data: availableBenefits } = useQuery({
    queryKey: ['benefits/available-benefits'],
    queryFn: () => benefitsService.getAvailableBenefits({}),
    enabled: true,
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.message || '';
      const statusCode = error?.response?.status;

      if (statusCode === 422) {
        // UnprocessableEntityException
        const missingData = extractMissingDataFromError(errorMessage);
        AlertAdapter(
          `Missing required data${
            missingData ? `: ${missingData}` : ''
          }. Please contact support to update your employee information before accessing benefits.`,
          'error'
        );
      }
    },
  });

  // eslint-disable-next-line no-unused-vars
  const { isLoading: pendingBenefitsLoading, data: pendingBenefits } = useQuery({
    queryKey: ['benefits/pending-benefits'],
    queryFn: benefitsService.getPendingBenefits,
    enabled: true,
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.message || '';
      const statusCode = error?.response?.status;

      if (statusCode === 422) {
        // UnprocessableEntityException
        const missingData = extractMissingDataFromError(errorMessage);
        AlertAdapter(
          `Missing required data${
            missingData ? `: ${missingData}` : ''
          }. Please contact support to update your employee information before accessing benefits.`,
          'error'
        );
      }
    },
  });

  const extractMissingDataFromError = (errorMessage: string): string => {
    // Extract specific missing data from error message

    // Pattern 1: "No agreement term id found for this employee."
    if (errorMessage.toLowerCase().includes('no agreement term id')) {
      return 'Agreement Term ID';
    }

    // Pattern 2: "No worker position found for this employee."
    if (errorMessage.toLowerCase().includes('no worker position')) {
      return 'Worker Position Data';
    }

    // Pattern 3: "Missing personnelNumber" -> "Personnel Number"
    const missingMatches = errorMessage.match(/missing\s+(\w+)/i);
    if (missingMatches && missingMatches[1]) {
      return missingMatches[1]
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, str => str.toUpperCase())
        .trim();
    }

    // Pattern 4: "No [something] found" -> extract the something
    const noFoundMatches = errorMessage.match(/no\s+([\w\s]+)\s+found/i);
    if (noFoundMatches && noFoundMatches[1]) {
      return noFoundMatches[1]
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, str => str.toUpperCase())
        .trim();
    }

    return '';
  };

  const handleNavigateToBenefitEvent = (path: string) => {
    try {
      navigate(path, { replace: true });
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || '';
      const statusCode = error?.response?.status;

      if (statusCode === 422) {
        const missingData = extractMissingDataFromError(errorMessage);
        AlertAdapter(
          `Missing required data${
            missingData ? `: ${missingData}` : ''
          }. Please contact support to update your employee information before accessing benefits events.`,
          'error'
        );
      }
    }
  };

  const getFirstTabComponent = useCallback(() => {
    if (availableBenefits?.length) {
      return <AvailableBenefitsList availableBenefits={availableBenefits} />;
    }
    return <EmptyBenefitsAvailable />;
  }, [availableBenefits]);

  const getSecondTabComponent = useCallback(() => {
    if (pendingBenefits?.length) {
      return <PendingBenefitsList pendingBenefits={pendingBenefits} />;
    }
    return <EmptyPending />;
  }, [pendingBenefits]);

  useEffect(() => {
    getPersonalInfo();
  }, []);
  const showNewHireButton = isNewHire;
  const showOpenEnrollmentButton = isOpenEnrollment;
  const showQleButton = isQle;
  const showBenefitUpdateButton = isBenefitUpdate;

  return (
    <Container>
      <Header>
        <HeaderItemLeft>
          <HeaderTitle>{t('benefits.header.title')}</HeaderTitle>
        </HeaderItemLeft>
        <HeaderItemRight>
          <RegularButton
            style={{ display: showNewHireButton ? 'block' : 'none' }}
            onClick={() => handleNavigateToBenefitEvent('/benefits/new-hire')}
            disabled={!isNewHire}
          >
            {t('benefits.header.button.newHire')}
          </RegularButton>
          <RegularButton
            style={{ display: showOpenEnrollmentButton ? 'block' : 'none' }}
            onClick={() => handleNavigateToBenefitEvent('/benefits/open-enrollment')}
            disabled={!isEnrollmentOpen}
          >
            {t('benefits.header.button.enrollment')}
          </RegularButton>
          <RegularButton
            style={{ display: showQleButton ? 'block' : 'none' }}
            onClick={() => handleNavigateToBenefitEvent('/benefits/qle')}
            disabled={!isQle}
          >
            {t('benefits.header.button.lifeEvents')}
          </RegularButton>
          <RegularButton
            style={{ display: showBenefitUpdateButton ? 'block' : 'none' }}
            onClick={() => handleNavigateToBenefitEvent('/benefits/ue')}
          >
            {t('benefits.header.button.updateEnrollment')}
          </RegularButton>
        </HeaderItemRight>
      </Header>
      <TabBenefits>
        <TabBenefitsContent
          onClick={() => setActive('active')}
          style={{
            background: active === 'active' ? 'white' : '#4948AC',
            color: active === 'active' ? 'black' : 'white',
          }}
        >
          Active
        </TabBenefitsContent>
        <TabBenefitsContent
          onClick={() => setActive('deductions')}
          style={{
            background: active === 'deductions' ? 'white' : '#4948AC',
            color: active === 'deductions' ? 'black' : 'white',
          }}
        >
          Enrollment History
        </TabBenefitsContent>
        <TabBenefitsContent
          onClick={() => setActive('currentDeductions')}
          style={{
            display: 'none',
            background: active === 'currentDeductions' ? 'white' : '#4948AC',
            color: active === 'currentDeductions' ? 'black' : 'white',
          }}
        >
          Deductions
        </TabBenefitsContent>
      </TabBenefits>
      <Content>
        {active === 'active' ? <CurrentBenefits active={active} /> : ''}
        {active === 'deductions' ? <CurrentBenefits active={active} /> : ''}
        {active === 'currentDeductions' ? <BenefitsListTable /> : ''}
        <CartTabs
          firstTabTitle="Available"
          FirstTabIcon={BenefitsAvailableIcon}
          secondTabTitle="Pending"
          SecondTabIcon={BenefitsPendingIcon}
          FirstTabContent={getFirstTabComponent}
          SecondTabContent={getSecondTabComponent}
        />
      </Content>
    </Container>
  );
};

export default BenefitsPage;
